import './style.scss';
import {
  OS_MASTERMAP_GREY_SCALE_BASEMAP,
  OS_ZOOMSTACK_BASEMAP,
} from 'constants/basemaps';

interface Props {
  currentLayer: string;
  onLayerChange: (title: string) => void;
  zoomStackIsAllowed: boolean;
  emapsiteBasemapsEnabled: boolean;
}

const Layers: React.FC<Props> = ({
  currentLayer = '',
  onLayerChange,
  zoomStackIsAllowed,
  emapsiteBasemapsEnabled,
}) => {
  const layerSelected = (ev: any) => {
    onLayerChange(ev.target.value);
  };

  return (
    <div className="xa-layers-container">
      {/* <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-1"
          value="OpenStreetMap"
          checked={currentLayer === "OpenStreetMap"}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label
          htmlFor="default-radio-1"
          className="xa-radio-label"
        >
          OpenStreetMap
        </label>
      </div> */}
      <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-1"
          value="StadiaMaps"
          checked={currentLayer === 'StadiaMaps'}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label htmlFor="default-radio-1" className="xa-radio-label">
          StadiaMaps
        </label>
      </div>
      <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-2"
          value="Alidade Smooth"
          checked={currentLayer === 'Alidade Smooth'}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label htmlFor="default-radio-2" className="xa-radio-label">
          Alidade Smooth
        </label>
      </div>
      <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-3"
          value="Alidade Smooth Dark"
          checked={currentLayer === 'Alidade Smooth Dark'}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label htmlFor="default-radio-3" className="xa-radio-label">
          Alidade Smooth Dark
        </label>
      </div>
      {/* <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-6"
          value="Alidade Satellite"
          checked={currentLayer === "Alidade Satellite"}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label
          htmlFor="default-radio-6"
          className="xa-radio-label"
        >
          Alidade Satellite
        </label>
      </div> */}
      <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-4"
          value="OSM Bright"
          checked={currentLayer === 'OSM Bright'}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label htmlFor="default-radio-4" className="xa-radio-label">
          OSM Bright
        </label>
      </div>
      <div className="xa-layer-item">
        <input
          type="radio"
          name="default-radio"
          id="default-radio-5"
          value="Google Satellite"
          checked={currentLayer === 'Google Satellite'}
          onChange={layerSelected}
          className="xa-radio-input"
        />
        <label htmlFor="default-radio-5" className="xa-radio-label">
          Google Satellite
        </label>
      </div>
      {emapsiteBasemapsEnabled && (
        <>
          <div className="xa-layer-item">
            <input
              type="radio"
              name="default-radio"
              id="default-radio-6"
              value={OS_ZOOMSTACK_BASEMAP}
              checked={currentLayer === OS_ZOOMSTACK_BASEMAP}
              onChange={layerSelected}
              className="xa-radio-input"
              disabled={!zoomStackIsAllowed}
            />
            <label htmlFor="default-radio-6" className="xa-radio-label">
              {OS_ZOOMSTACK_BASEMAP}
            </label>
          </div>
          <div className="xa-layer-item">
            <input
              type="radio"
              name="default-radio"
              id="default-radio-7"
              value={OS_MASTERMAP_GREY_SCALE_BASEMAP}
              checked={currentLayer === OS_MASTERMAP_GREY_SCALE_BASEMAP}
              onChange={layerSelected}
              className="xa-radio-input"
              disabled={!zoomStackIsAllowed}
            />
            <label htmlFor="default-radio-7" className="xa-radio-label">
              {OS_MASTERMAP_GREY_SCALE_BASEMAP}
            </label>
          </div>
        </>
      )}

      
    </div>
  );
};
export default Layers;
